/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateNotificationTemplateItem } from './update-notification-template-item';


export interface UpdateNotificationRequest { 
    identifier: string;
    description: string;
    groupId: number;
    templates?: Array<UpdateNotificationTemplateItem> | null;
}

